import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-avatar-user',
  imports: [CommonModule],
  templateUrl: './avatar-user.html'
})
export class AvatarUser {

  @Input() avatarSrc: string = '';
  @Input() userName: string = '';
  @Input() w: string = 'w-32';
  @Input() h: string = 'h-32';

  get userInitial(): string {
    if (!this.userName) return '?';
    return this.userName.charAt(0).toUpperCase();
  }
}
